import { useState } from 'react'
import { IoTrash } from 'react-icons/io5'
import { IconButton } from '@chakra-ui/react'
import { Button, AlertDialog } from 'uikit'
import { useHistory } from 'react-router-dom'
import { useDeleteCatalogItem } from './useDeleteCatalogItem'

export const Delete = ({ id }) => {
  const history = useHistory()
  const [isOpen, setIsOpen] = useState(false)
  const { mutate: deleteItem, isPending: isLoadingDeleteItem } = useDeleteCatalogItem()

  const handleDelete = () => {
    deleteItem(id, {
      onSuccess: () => {
        history.goBack()
      }
    })
  }

  return (
    <>
      <IconButton aria-label="Delete" borderRadius="full" onClick={() => setIsOpen(true)}>
        <IoTrash />
      </IconButton>
      <AlertDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Удаление события"
        footer={
          <>
            <Button onClick={() => setIsOpen(false)}>Отмена</Button>
            <Button loading={isLoadingDeleteItem} colorPalette="red" ml={3} onClick={handleDelete}>
              Удалить
            </Button>
          </>
        }
      >
        Вы действительно хотите удалить событие?
      </AlertDialog>
    </>
  )
}
